import { ApiProperty } from '@nestjs/swagger';

export class PTypeDto {
  @ApiProperty()
  poTypeId: number;

  @ApiProperty()
  orderType: string;

  @ApiProperty()
  plantId: number;

  @ApiProperty()
  plantName?:string
  
  @ApiProperty()
  isActive: boolean;
  createdAt : Date;

  @ApiProperty()
  createdUser : string;
  updatedAt : Date;
  
  @ApiProperty()
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

